let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("55bMA")).then(() => parcelRequire('ipfev'));